import { CastHelper } from './cast.helper';
import { Expose, Transform, Type } from 'class-transformer';
import {
  IsBoolean,
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { BaseDto, BaseFiltersDto } from './base.dto';
import { CardDto, CreateCardDto } from './cards.dto';
import { CardState } from '@coworkrz/cards/types';

export class CreateMemberDto {
  @IsString()
  @IsNotEmpty()
  firstName: string;

  @IsString()
  @IsNotEmpty()
  lastName: string;

  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsNotEmpty()
  phoneNumber?: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => CreateCardDto)
  card: CreateCardDto;
}

export class UpdateMemberDto {
  @IsString()
  @IsOptional()
  firstName: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsEmail()
  @IsOptional()
  email?: string;

  @IsString()
  @IsOptional()
  phoneNumber?: string;
}

export class MembersFiltersDto extends BaseFiltersDto {
  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  active?: boolean;

  @IsOptional()
  @IsUUID()
  teamId?: string;

  @Transform(({ value }) => CastHelper.toBoolean(value))
  @IsOptional()
  @IsBoolean()
  withNoTeam?: boolean;

  @Transform(({ value }) => CastHelper.trim(value))
  @IsOptional()
  unlimitedSubscription?: string;

  @IsOptional()
  @IsEmail()
  email?: string;
}

@Expose()
export class MemberPreviewDto extends BaseDto {
  @Expose() firstName: string;

  @Expose() lastName: string;

  @Expose() email: string;

  @Expose() phoneNumber: string;

  @Expose() memberSince: Date;

  @Expose() fullName: string;

  @Expose() @Type(() => CardDto) card: CardDto;

  @Expose()
  isActive: boolean;
}

export class MemberDto extends MemberPreviewDto {}
